// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__Sknx4","signatureButtonsRight":"ModalSign_signatureButtonsRight__1tm8K"};